export default "__VITE_ASSET__D5hCv32v__"